<script>
export default {
  name: 'UnionNavBarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#030309',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 13 55"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 0C1 7.47303 1 27.0094 1 42.0057C1 48.6331 6.37258 54 13 54V54"
      :stroke="color"
    />
  </svg>
</template>
